// extracted by mini-css-extract-plugin
module.exports = {"status":"Subscribe_status__3f_C_","subscribe":"Subscribe_subscribe__2Qe6b"};